import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/api-client';

export const creditBalanceQueryKey = ['credit-balance'] as const;

/** The signed-in user's credit balance (header chip). Pass `false` while signed out. */
export function useCreditBalance(enabled: boolean) {
  return useQuery({
    queryKey: creditBalanceQueryKey,
    queryFn: () => apiGet<{ balance: number }>('/api/credits/balance'),
    enabled,
    staleTime: 30_000,
  });
}
